export default __webpack_public_path__ + "static/media/left_trees2.a63419f6.svg";